import { Navigation, Line } from './styles';

/**
 * useRef permite que persista valores entre renderizações, ele pode
 * ser usado para armazenar um valor mutável que não causa uma nova
 * renderização quando atualizado e pode ser usado para acessar di-
 * retamente um elemento do DOM.
 * 
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useRef, useState, useEffect } from 'react';

/**
 * TabNavigation
 * 
 * @param {array} views
 * @param {*} activeView
 * @param {function} moveTo
 * @returns 
 */
const TabNavigation = ({ views, activeView, moveTo }) => {
  const activeItem = useRef(null);
  const [lineParams, setParams] = useState({
    top: 35,
    left: 150,
    width: 0,
  });
  
  const viewsTitle = views.reduce((acc, cur) => [...acc, cur.title], []);
  const validView = views.reduce((acc, cur) => [...acc, cur.valid], []);
  
  useEffect(() => {
    if (typeof activeView !== 'undefined' && activeItem.current) {
      setParams({
        top: activeItem.current.offsetTop + 30,
        left: activeItem.current.offsetLeft,
        width: activeItem.current.offsetWidth,
      });
    }
  }, [activeView]);

  const handleOver = (e) => {
    setParams({
      top: e.target.offsetTop + 30,
      left: e.target.offsetLeft,
      width: e.target.offsetWidth,
    });
  };

  const handleOut = (e) => {
    setParams({
      top: activeItem.current.offsetTop + 30,
      left: activeItem.current.offsetLeft,
      width: activeItem.current.offsetWidth,
    });
  };

  return (
    <Navigation>
      <div className="space" />
      {views.map((e, i) => {
        return (
          <button
            key={i}
            ref={i === activeView ? activeItem : null}
            onMouseOver={handleOver}
            onMouseOut={handleOut}
            onClick={moveTo(i)}
            disabled={!(i === 0 || validView[i] === true)}
            className={i === activeView ? 'active' : null}
          >
            {viewsTitle.length ? viewsTitle[i] : `Passo ${i + 1}`}
          </button>
        );
      })}
      <Line
        top={lineParams.top}
        left={lineParams.left}
        width={lineParams.width}
        background={views[activeView] && views[activeView].bgColor}
      />
    </Navigation>
  );
};

TabNavigation.properties = {
  ignore: true,
};

export default TabNavigation;
